import { render, staticRenderFns } from "./PluginDetail.vue?vue&type=template&id=64bb0894&scoped=true"
import script from "./PluginDetail.vue?vue&type=script&lang=js"
export * from "./PluginDetail.vue?vue&type=script&lang=js"
import style0 from "./PluginDetail.vue?vue&type=style&index=0&id=64bb0894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb0894",
  null
  
)

export default component.exports